import React from "react"
import { motion } from "framer-motion"

const TransferOption = ({
  title,
  subtitle,
  price,
  passengers,
  index,
  nonRefundable,
  handleBook,
  onRequest,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -12 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25, delay: index * 0.06, ease: "easeOut" }}
      className="flex items-center justify-between px-3 sm:px-4 py-3 rounded-xl border border-gray-100 bg-white hover:border-app-base-strong/40 hover:shadow-sm transition-all duration-200 cursor-pointer"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="min-w-0">
          <p className="text-sm font-medium text-app-content leading-tight truncate">{title}</p>
          <p className="text-xs text-app-content-faint mt-0.5">{subtitle}</p>
          <div className="flex flex-wrap items-center gap-1.5 mt-1.5">
            {onRequest && (
              <span className="inline-flex items-center gap-1 text-[10px] font-medium text-amber-500 bg-amber-50 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block" />
                On Request
              </span>
            )}

            {nonRefundable && (
              <span className="inline-flex items-center gap-1 text-[10px] font-medium text-red-400 bg-red-50 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-red-400 inline-block" />
                Non refundable
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-end gap-1 shrink-0 ml-3">
        <motion.button
          onClick={handleBook}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="px-4 py-2 bg-app-base-strong hover:bg-app-base text-white text-sm font-semibold rounded-lg transition-colors duration-150 shadow-sm shadow-app-base-strong/20 whitespace-nowrap"
        >
          €{price.toFixed(2)}
        </motion.button>
        <span className="flex items-center gap-1 text-[10px] text-app-content-faint">
          <UserIcon />
          {passengers} pax
        </span>
      </div>
    </motion.div>
  )
}

const UserIcon = () => (
  <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
    />
    <circle cx="12" cy="7" r="4" />
  </svg>
)

export default TransferOption
